import { Box, Flex } from "@chakra-ui/react";
import { Car } from "lucide-react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "pixelize-design-library";
import { useNavigate } from "react-router";
import { selectAcknowledgeSignUp, selectJustSignedUp, useSession } from "@core/auth";
import { brandColors, radii } from "@core/theme";

export const AddVehiclePrompt = () => {
  const navigate = useNavigate();
  const isOpen = useSession(selectJustSignedUp);
  const acknowledge = useSession(selectAcknowledgeSignUp);

  const handleAddVehicle = () => {
    acknowledge();
    void navigate("/vehicles/add");
  };

  return (
    <Modal isOpen={isOpen} onClose={acknowledge} size="sm">
      <ModalHeader>
        <Flex direction="column" align="center" gap={2}>
          <Flex
            align="center"
            justify="center"
            boxSize="56px"
            borderRadius={radii.full}
            bg={brandColors.primary[50]}
          >
            <Car size={28} color={brandColors.primary[600]} />
          </Flex>
          <Box textAlign="center">Welcome! Add your vehicle</Box>
        </Flex>
      </ModalHeader>
      <ModalBody>
        <Box textAlign="center" fontSize="sm" color={brandColors.gray[500]}>
          Save your vehicle&apos;s make, model and year so we can show you parts that fit, every
          time you shop.
        </Box>
      </ModalBody>
      <ModalFooter>
        <Flex direction="column" gap={2} width="100%">
          <Button
            label="Add Vehicle"
            colorScheme="primary"
            width="100%"
            onClick={handleAddVehicle}
          />
          <Button label="Maybe later" variant="ghost" width="100%" onClick={acknowledge} />
        </Flex>
      </ModalFooter>
    </Modal>
  );
};
